import type MatchPlanModel from '../models/match-plan.ts';

export function getTranslationKeyForReportedSalaryForMatchPlan(matchPlan: MatchPlanModel) {
  const key = (matchPlan.qualifyingIncome || '').split('.').pop()?.toLowerCase() || 'unknown';
  return `syf.qualifying_income.${key}`;
}

export default null; // silence a false warning
